import React from 'react';
import { useTranslation } from 'react-i18next';

const YesNoDialog = ({ show, model, onClosePopup }) => {
	const { t } = useTranslation();

	const onClose = React.useCallback(() => {
		if (onClosePopup) {
			onClosePopup();
		}
	}, [onClosePopup]);

	const yes = React.useCallback((e) => {
		e.stopPropagation();
		if (onClosePopup) {
			onClosePopup();
		}

		if (model?.onYes) {
			model.onYes();
		}
	}, [onClosePopup, model]);

	const no = React.useCallback((e) => {
		e.stopPropagation();
		if (onClosePopup) {
			onClosePopup();
		}

		if (model?.onNo) {
			model.onNo();
		}
	}, [onClosePopup, model]);

	return (
		(show &&
			<div
				className="dialogBox"
				onClick={onClose}
			>
				<div className="dialogBoxWindow" style={{
					width: '300px',
				}}>
					<header>
						<a className="close cursor">X</a>
					</header>
					<main>

						<div style={{
							padding: '10px 5px 5px 5px',
							textAlign: 'center',
						}}>
							<p >{model.message || t('Having fun?')}</p>
						</div>

					</main>
					<footer>
						<div style={{
							padding: '10px 5px 5px 5px',
							textAlign: 'center',
						}}>
							<a className="simpleButtonOutLine" onClick={yes} style={{
								width: '100px',
							}}>
								{t('Yes')}
							</a>
							<a className="simpleButtonOutLine" onClick={no} style={{
								width: '100px',
							}}>
								{t('No')}
							</a>
						</div>
					</footer>
				</div>
			</div>
		)
	);
};

export default YesNoDialog;
